import React from 'react';

import { Background } from '../../components/Login/Background/Background';
import Strings from '../../Strings';
import { getStoredSessionTimeoutMinutes } from '../../utils/sessionTimeout';
import styles from './SessionExpiredPage.module.scss';

export default function SessionExpiredPage() {
  const queryParams = new URLSearchParams(window.location.search);
  const isEsi = queryParams.get('esi') === '1';
  const loginPath = isEsi ? '/login-esi-patient' : '/login';
  const inactivityMinutes = getStoredSessionTimeoutMinutes();
  const inactivityMessage = Strings.sessionExpiredInactivityMessageWithDuration
    ? Strings.formatString(Strings.sessionExpiredInactivityMessageWithDuration, inactivityMinutes)
    : `You have been logged out due to ${inactivityMinutes} minutes of inactivity.`;

  return (
    <Background title={Strings.sessionExpiredTitle || 'Session Expired'}>
      <div className={styles.container}>
        <p className={styles.message}>
          {inactivityMessage}
        </p>
        <a href={loginPath} className={styles.loginButton}>
          {Strings.sessionExpiredLoginButton || 'Log in again'}
        </a>
      </div>
    </Background>
  );
}
